import { render, staticRenderFns } from "./cv-detail.vue?vue&type=template&id=5649f75a&scoped=true"
import script from "./cv-detail.vue?vue&type=script&lang=ts"
export * from "./cv-detail.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5649f75a",
  null
  
)

export default component.exports